/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

const requiredMetaContent = (elementId: string) => {
	const element = document.getElementById(elementId);
	if (!element)
		throw 'Document MUST contain element with id "' + elementId + '"';

	const content = element.getAttribute('content');
	if (!content)
		throw 'Element "' + elementId + '" MUST have non-empty content value';

	return content;
};

export const IAM_BASE_URL: string = requiredMetaContent('iam_base_url');
